import React, { useState } from "react"
import { Image, Flex, Box, Text, Button } from "rebass"
import styled from "@emotion/styled"

import Reveal from "../reveals"
import RowWrapper from "./RowWrapper"

const RowTabsComponent = ({ data }) => {
  const { title, titleHeadingTag, text, tabs, revealAnimation } = data
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  return (
    <RowWrapper {...data}>
      <Box
        as="header"
        justifyContent="center"
        flexDirection="column"
        px={['15px', null, 5]}
        pb={['20px', null, 5]}
      >
        {title && <Text as={titleHeadingTag}>{title}</Text>}
        {text && <Box dangerouslySetInnerHTML={{ __html: text }} />}
      </Box>

      {tabs && (
        <Flex flexDirection={["column-reverse", null, null, "row-reverse"]}>
          {/* All Tabs content */}
          <Flex
            as="aside"
            flexDirection="column"
            width={[1, null, null, 1/2]}
            py={[0, null, null, 6]}
            pl={[0, null, null, 5]}
          >
            {tabs.map((tab, index, array) => {
              return (
                <Reveal delay={0.15 * index} animation={revealAnimation} key={index}>
                  <Button
                    key={index}
                    variant="tabs"
                    as={TabButton}
                    mt={index > 0 ? 2 : 0}
                    mb={index < array.length - 1 ? 2 : 0}
                    width="100%"
                    selected={index === selectedTabIndex}
                    onClick={() => setSelectedTabIndex(index)}
                  >
                    {tab.title}
                  </Button>
                </Reveal>
              )
            })}
          </Flex>

          {/* figures */}
          <Box as={TabsImages} width={[1, null, null, 1/2]} pb={['20px', null, null, 0]}>
            <Reveal animation="from-left">
              {tabs.map((tab, index) => {
                return (
                  <Image
                    key={index}
                    as={TabImage}
                    selected={index === selectedTabIndex}
                    alt={tab.image.title}
                    srcSet={tab.image.srcSet}
                  />
                )
              })}
            </Reveal>
          </Box>
        </Flex>
      )}
    </RowWrapper>
  )
}

export default RowTabsComponent

// component styles

const TabButton = styled.button(props => ({
  outline: "none !important",
  background: `${props.selected && props.theme.colors.text} !important`,
  borderColor: `${props.selected && props.theme.colors.text} !important`,
  color: `${props.selected && props.theme.colors.background} !important`,
}))

const TabsImages = styled.aside`
  position: relative;
`
const TabImage = styled.img`
  display: ${props => (props.selected ? "block" : "none")};
  width: 100%;
  height: auto;

  @media (min-width: ${props => props.theme.breakpoints[2]}) {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    object-fit: cover;
    transform-origin: center center;
    animation: tabsImages 850ms 50ms cubic-bezier(0.215, 0.610, 0.355, 1.000) both; /* easeOutCubic */
  }
`
